import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage(): null {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard/club');
  }, [navigate]);

  return null;
}
